const setImageSize = (img) => {
  if (img) {
    img.style.height = 'auto';
    img.style.width = '100%';
    var imgHeight = img.getBoundingClientRect().height;
    var textBoxHeight = img.previousElementSibling.getBoundingClientRect().height;
    var minimumPadding = 80;
    if (textBoxHeight > imgHeight - minimumPadding) {
      img.style.height = textBoxHeight + minimumPadding + 'px';
      img.style.width = 'unset';
    }
  }
};

const debounce = (func) => {
  var timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
};

document.addEventListener('DOMContentLoaded', function () {
  var images = document.querySelectorAll('.highlightWithButton .highlight-desktop img');

  images.forEach((image) => {
    image.addEventListener('load', () => {
      setImageSize(image);
    });
  });

  window.addEventListener(
    'resize',
    debounce(() => {
      images.forEach((image) => {
        if (image.complete && image.naturalHeight !== 0) {
          setImageSize(image);
        }
      });
    })
  );
});
